import { BaseModel } from "sjs-base-model";

// InfluencersActivityPostModel
export default class InfluencersActivityPostModel extends BaseModel {
    /*
     * Client-Side properties (Not from API)
     */
    // noneApiProperties = null;
    // response getting from the api mentioned end point

    status = "";

    constructor(data1) {
        super();

        this.update(data1);
    }
}
